module.exports = __webpack_public_path__ + "img/icon101.d31cc05a.png";